<template>
  <div class="mx-auto flex w-full flex-col gap-6">
    <header class="border-b pb-4">
      <div>
        <h1 class="text-3xl font-bold tracking-tight">
          {{ $t('chat.admin.title') }}
        </h1>
        <p class="text-sm text-muted-foreground">
          {{ $t('chat.admin.subtitle') }}
        </p>
      </div>
    </header>

    <RouterView />
  </div>
</template>
